<template>
    <v-row class="mainRow flex-nowrap pa-0 pt3 ml-5 ma-0 elevation-1">
<!-- Filtros Pedido -->
        <filtros-pedido @loadPedido="loadDados($event)" :filtroSelecionado.sync="filtroSelecionado"
                        @limparDtPrevista="setarDtPrevista(null)" :filtros="filtros" />
<!-- Main Screen -->
        <v-sheet class="middleScreen flex-column flex-fill pa-8" >
            <v-row class="mb-8">
                <v-col class="pa-0 mr-2">
                    <span class="data-label">Produtor</span>
                    <v-text-field outlined dense v-model="queryFiltros.nmProdutor" :loading="loadingPedidos" clearable
                                  color="#2BC1B6" @keydown.enter="loadDados()" />
                </v-col>
                <v-col class="pa-0 mr-2">
                    <span class="data-label">Pavilhão</span>
                    <v-text-field outlined dense v-model="queryFiltros.nrPavilhao" :loading="loadingPedidos" clearable
                                  color="#2BC1B6" @keydown.enter="loadDados()" />
                </v-col>
                <v-col class="pa-0 mr-2">
                    <span class="data-label">Observação</span>
                    <v-text-field outlined dense v-model="queryFiltros.dsObservacao" :loading="loadingPedidos" clearable
                                  color="#2BC1B6" @keydown.enter="loadDados()" />
                </v-col>
                <v-col class="pa-0 mr-2">
                    <span class="data-label">UEP</span>
                    <v-text-field outlined dense v-model="queryFiltros.nrUep" :loading="loadingPedidos" clearable
                                  color="#2BC1B6" v-mask="'########'" @keydown.enter="loadDados()" />
                </v-col>
                <v-col class="pa-0 mr-2">
                    <span class="data-label">Identificador</span>
                    <v-text-field outlined dense v-model="queryFiltros.idPedidoRacao" :loading="loadingPedidos" clearable
                                  color="#2BC1B6" v-mask="'########'" @keydown.enter="loadDados()" />
                </v-col>
                <v-btn elevation="0" color="#2BC1B6" height="40" class="btn-buscar align-self-center" dark
                       @click="loadDados()">
                    Buscar
                </v-btn>

            </v-row>
            <v-row class="dt-row rounded-t">
                <v-data-table
                    calculate-widths
                    class="elevation-1 data-table"
                    item-class="clickable"
                    :headers.sync="headers"
                    :items="listaDados"
                    :options.sync="optionsDT"
                    :server-items-length="totalItemsDT"
                    :loading="loadingPedidos"
                    @click:row="goToDetalhePedido"
                    :footer-props="{
                        itemsPerPageOptions: [15, 30, 45],
                        prevIcon: 'fas fa-chevron-circle-left',
                        nextIcon: 'fas fa-chevron-circle-right'
                    }">
                    <template v-slot:item.cdStatusPedidoRacao="{ item }">
                        <v-icon v-if="item.cdStatusPedidoRacao === 4" size="22px" color="#33D6AB">
                            fas fa-check
                        </v-icon>
                    </template>
                </v-data-table>
            </v-row>
        </v-sheet>
<!-- Entregas Pedido -->
        <entregas-pedido @loadPedido="loadDados($event)" @setarDtPrevista="setarDtPrevista($event)"
                         :dt-prevista-prop="queryFiltros.dtPrevista" />
    </v-row>
</template>

<script>
import * as moment from 'moment';
import {mask} from 'vue-the-mask';
import {URLS, MODELS} from "@/modules/pedidosRacao/resources";
import FiltrosPedido from "@/modules/pedidosRacao/components/pedidosRacao/FiltrosPedido";
import EntregasPedido from "@/modules/pedidosRacao/components/pedidosRacao/EntregasPedido";

export default {
    name: "pedidosRacao.vue",
    directives: {mask},
    components: {EntregasPedido, FiltrosPedido},
    data: () => ({
        filtros: MODELS.TIPOFILTROS,
        filtroSelecionado: 0,
        headers: MODELS.HEADERSTABLE[URLS.SOLICITADOS],
        listaDados: [],
        optionsDT: {},
        totalItemsDT: 1,
        queryFiltros: MODELS.QUERYFILTROS,
        loadingPedidos: false,
    }),
    watch: {
        optionsDT: {
            handler() {
                this.loadDados();
            },
            deep: true,
        },
    },
    methods: {
        loadDados(evento) {
            this.loadingPedidos = true;

            if (evento && evento.blLimparFiltros) this.limparQueryFiltros()
            this.queryFiltros.endpoint = evento && evento.endpoint ? evento.endpoint : this.queryFiltros.endpoint

            this.setarHeaders(this.queryFiltros.endpoint)

            const getById = this.queryFiltros.idPedidoRacao > 0

            const { sortBy, sortDesc, page, itemsPerPage } = this.optionsDT;

            let query = {};
            if (this.queryFiltros.nmProdutor && this.queryFiltros.nmProdutor !== '')
                query['nm_produtor'] = this.queryFiltros.nmProdutor;
            if (this.queryFiltros.dsObservacao && this.queryFiltros.dsObservacao !== '')
                query['ds_observacao'] = this.queryFiltros.dsObservacao;
            if (this.queryFiltros.nrUep && this.queryFiltros.nrUep > 0)
                query['nr_uep'] = this.queryFiltros.nrUep;
            if (getById)
                query['id_pedido_racao'] = this.queryFiltros.idPedidoRacao;
            if (this.queryFiltros.dtPrevista)
                query['dt_prevista'] = this.queryFiltros.dtPrevista;
            if (page && page > 0)
                query['page'] = page;
            if (itemsPerPage && itemsPerPage > 0)
                query['per_page'] = itemsPerPage;

            this.$axios
                .get(
                  process.env.VUE_APP_URL_API + this.queryFiltros.endpoint, { params: query }
                )
                .then(res => {
                    if (!res.data[0]) return
                    this.listaDados = [];
                    if (!res.data[0].data) return

                    const response  = res.data[0].data;

                    for (let i = 0; i < response.length; i++) {
                        response[i].dtDesejada = response[i].dtDesejada ?
                        moment(response[i].dtDesejada, 'YYYY-MM-DD').format('DD/MM/YYYY') : null;

                        response[i].dtPrevista = response[i].dtPrevista ?
                        moment(response[i].dtPrevista, 'YYYY-MM-DD').format('DD/MM/YYYY') : null;
                    }

                    if(getById) this.setarFiltro(response[0].cdStatusPedidoRacao, response[0].blAtrasado)
                    if(this.queryFiltros.dtPrevista) this.setarFiltro(2,  this.queryFiltros.endpoint === URLS.ATRASADOS)

                    this.listaDados = response.sort((a, b) => {
                        return (
                            new Date(b.idPedidoRacao) - new Date(a.idPedidoRacao)
                        )
                    });
                    this.totalItemsDT = res.data[0].meta.total_itens;
                })
                .catch(error => {
                  this.$store.commit("setSnack", { type: "error", msg: error });
                })
                .finally(() => {
                    this.loadingPedidos = false;
                })
        },
        loadFiltros() {
                this.$axios
                .get(
                  process.env.VUE_APP_URL_API + URLS.TOTAIS
                )
                .then(res => {
                    if (!res.data[0]) return
                    if (!res.data[0].data) return

                    this.filtros = res.data[0].data;
                    this.totalItemsDT = this.filtros.solicitados.nr_pedidos;
                })
                .catch(error => {
                  this.$store.commit("setSnack", { type: "error", msg: error });
                })
        },
        limparQueryFiltros() {
            this.queryFiltros.nmProdutor = '';
            this.queryFiltros.dsObservacao = '';
            this.queryFiltros.nrUep = '';
            this.queryFiltros.idPedidoRacao = '';
            this.optionsDT.page = 1;
        },
        setarDtPrevista(dtPrevista) {
            this.queryFiltros.dtPrevista = dtPrevista
        },
        goToDetalhePedido(value) {
            this.$router.push(URLS.DETALHEPEDIDO + value.idPedidoRacao);
        },
        setarFiltro(cdStatusPedido, blAtrasado) {
            switch(cdStatusPedido) {
                case 1:
                    this.filtroSelecionado = 0;
                    this.setarHeaders(URLS.SOLICITADOS)
                    break;
                case 2:
                    if (!blAtrasado) this.filtroSelecionado = 1
                    else this.filtroSelecionado = 2;
                    this.setarHeaders(URLS.CONFIRMADOS)
                    break;
                case 3:
                case 4:
                    this.filtroSelecionado = 4;
                    this.setarHeaders(URLS.FINALIZADOS)
                    break;
                case 5:
                    this.filtroSelecionado = 3;
                    this.setarHeaders(URLS.CANCELADOS)
                    break;
            }
        },
        setarHeaders(endpoint) {
            this.headers = MODELS.HEADERSTABLE[endpoint];
        }
    },
    filters: {
        formataData(date, ISO, formatoSaida) {
            let tipoData = ISO ? moment.ISO_8601 : 'YYYY-MM-DD';
            const parsedDate = moment(date, tipoData);
            if (!parsedDate.isValid()) return "";
            return parsedDate.format(formatoSaida);
        },
    },
    created() {
        this.loadFiltros()
        this.loadDados({endpoint: URLS.SOLICITADOS})
    }
}
</script>

<style lang="scss" scoped>
@import "src/modules/pedidosRacao/sass/variables";

.mainRow {
  height: 100%;
  background: $gray-500;
  border-left: 1px solid $gray-400;
}

.middleScreen {
  background: $white-200;
}

.data-table {
  width: 100%;
}

.btn-buscar {
  margin-bottom: 2px;
  height: 40px;
}

.data-label {
  text-align: left;
  font: normal normal normal 10px/13px Roboto;
  letter-spacing: 0;
  color: $gray-350;
  opacity: 1;
}

.dt-row {
  position: relative;
  top: -28px
}

.v-alert {
  background: $white-100;
}

.v-data-table:hover {
  cursor: pointer !important;
}
</style>